<template>
    <td :colspan="colspan">
        <div class="alert alert-danger" v-if="data.capacity_warning.show">
            <i class="fas fa-exclamation-triangle"></i>
            We don't have the capacity to deliver.
            Capacity {{ data.capacity_warning.mc_capacity }} MC, {{ data.capacity_warning.direct_capacity }} directs.
            You requested: {{ data.capacity_warning.mc_order }} MC, {{ data.capacity_warning.direct_order }} directs.
        </div>
    </td>
</template>

<script>
export default {
    props: [
        'colspan', 'data'
    ]
}
</script>